import { render, staticRenderFns } from "./AdvertismentTableView.vue?vue&type=template&id=44e2deef&scoped=true"
import script from "./AdvertismentTableView.vue?vue&type=script&lang=js"
export * from "./AdvertismentTableView.vue?vue&type=script&lang=js"
import style0 from "./AdvertismentTableView.vue?vue&type=style&index=0&id=44e2deef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2deef",
  null
  
)

export default component.exports